export const SEARCH_TRACKING_TYPE = {
    productDetail: 'product_detail',
    brandPage: 'brand_page',
    brand: 'brand',
};
